import { initializeApp, FirebaseApp } from 'firebase/app';
import { getAuth, Auth } from 'firebase/auth';
import { getFirestore, Firestore } from 'firebase/firestore';
import { getStorage, FirebaseStorage } from 'firebase/storage';
// Firebase config interface
interface FirebaseConfig {
  apiKey: string;
  authDomain: string;
  projectId: string;
  storageBucket: string;
  messagingSenderId: string;
  appId: string;
  measurementId?: string;
}

//TODO: Make this dynamic and use the environment variable from the .env file

// Read from env (CRA requires REACT_APP_ prefix)
const firebaseConfig: FirebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY || '',
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || '',
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID || '',
  // For most projects the default bucket uses the pattern: <project-id>.appspot.com
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_ID || '',
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || '',
  appId: process.env.REACT_APP_FIREBASE_APP_ID || '',
  // Optional
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};


function assertConfig(config: FirebaseConfig): void {
  const missing = Object.entries(config)
    .filter(([key, value]) => {
      // measurementId can be undefined; others are required
      if (key === 'measurementId') return false;
      return !value || String(value).trim() === '';
    })
    .map(([key]) => key);

  if (missing.length) {
    // Provide a clear error in development
    // eslint-disable-next-line no-console
    console.error(
      'Firebase config is missing the following env vars:',
      missing
    );
    throw new Error(
      `Firebase configuration incomplete. Missing: ${missing.join(', ')}. Did you set your .env with REACT_APP_ variables and restart?`
    );
  }
}

assertConfig(firebaseConfig);

// Initialize Firebase
const app: FirebaseApp = initializeApp(firebaseConfig);

// Initialize Firebase services
export const auth: Auth = getAuth(app);

//if the environment is production, use the production name staging else testing
export const database: Firestore = getFirestore(app, process.env.REACT_APP_FIREBASE_DATABASE_ID || 'default');
export const storage: FirebaseStorage = getStorage(app);

// Initialize Analytics only if available and in browser
export let analytics: any;
if (typeof window !== 'undefined' && firebaseConfig.measurementId) {
  // Dynamically import to avoid bundling issues when not configured
  import('firebase/analytics')
    .then(({ getAnalytics }) => {
      analytics = getAnalytics(app);
    })
    .catch(() => {
      // eslint-disable-next-line no-console
      console.warn('Firebase Analytics not initialized.');
    });
}

export default app;
